import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import axios from "axios";
import { Dialog, Button, Dropdown, TextInput, Image } from "hesus-ui-kit";
import ClipLoader from "react-spinners/ClipLoader";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
} from "@utils/extra-style";
import UserInfo from "@utils/UserInfo";
import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  GridRow,
} from "./AddEditTransport.styled";
import closeIcon from "@icons/ic-close-white.svg";

const AddEditTransport = (props) => {
  const {
    t,
    id,
    isEditMode,
    title,
    onClose,
    updateRefeshStatus,
    selectedTransport,
  } = props;
  const [isTransportCreating, setIsTransportCreating] = useState(false);
  const [createTransportAPIError, setCreateTransportAPIError] = useState("");
  const [productList, setProductList] = useState([]);
  const generalParams = useGetGeneralParameters();
  const userDetails = UserInfo.getUser();

  const [formData, setFormData] = useState({
    name: {
      required: true,
      value: selectedTransport?.name ?? "",
      error: "",
    },
    volume: {
      required: true,
      value: selectedTransport?.volume ?? "",
      error: "",
    },
    avgWeight: {
      required: true,
      value: selectedTransport?.averageWeight ?? "",
      error: "",
    },
    minWeight: {
      required: true,
      value: selectedTransport?.minWeight ?? "",
      error: "",
    },
    maxWeight: {
      required: true,
      value: selectedTransport?.maxWeight ?? "",
      error: "",
    },
    country: {
      required: true,
      value: selectedTransport?.country?.id ?? "",
      error: "",
    },
    product: {
      required: true,
      value: selectedTransport?.product?.id ?? "",
      error: "",
    },
    isActive: {
      required: true,
      value: selectedTransport?.isActive ?? true,
      error: "",
    },
  });

  const onCountryChange = (e) => {
    setFormData({
      ...formData,
      country: {
        value: e.value,
        error: "",
        required: true,
      },
      product: {
        value: "",
        error: "",
        required: true,
      },
    });
  };
  const onNameChange = (e) => {
    setFormData({
      ...formData,
      name: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onVolumeChange = (e) => {
    setFormData({
      ...formData,
      volume: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onAvgWeightChange = (e) => {
    setFormData({
      ...formData,
      avgWeight: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onMinWeightChange = (e) => {
    setFormData({
      ...formData,
      minWeight: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onMaxWeightChange = (e) => {
    setFormData({
      ...formData,
      maxWeight: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onProductChange = (e) => {
    setFormData({
      ...formData,
      product: {
        value: e.value,
        error: "",
        required: true,
      },
    });
  };
  const validateForm = (data) => {
    let isFormValid = true;
    if (!data.country.value) {
      isFormValid = false;
      data.country.error = t("GENERAL_MANDATORY_ERROR");
    }
    if (!data.name.value) {
      isFormValid = false;
      data.name.error = t("GENERAL_MANDATORY_ERROR");
    }
    if (!data.volume.value) {
      isFormValid = false;
      data.volume.error = t("GENERAL_MANDATORY_ERROR");
    }
    if (!data.avgWeight.value) {
      isFormValid = false;
      data.avgWeight.error = t("GENERAL_MANDATORY_ERROR");
    }
    if (!data.minWeight.value) {
      isFormValid = false;
      data.minWeight.error = t("GENERAL_MANDATORY_ERROR");
    }
    if (!data.maxWeight.value) {
      isFormValid = false;
      data.maxWeight.error = t("GENERAL_MANDATORY_ERROR");
    }
    if (!isFormValid) {
      setFormData({ ...data });
    }

    return isFormValid;
  };

  const getFormData = () => {
    const data = {
      id: isEditMode ? selectedTransport.id : "",
      name: formData.name.value,
      volume: formData.volume.value,
      averageWeight: formData.avgWeight.value,
      minWeight: formData.minWeight.value,
      maxWeight: formData.maxWeight.value,
      product: JSON.stringify({
        id: formData.product.value,
      }),
      country: JSON.stringify({
        id: formData.country.value,
      }),
      createdBy: JSON.stringify({
        id: userDetails.id,
      }),
    };
    return data;
  };

  const fetchProducts = () => {
    axios
      .get(
        `/products?status=1&subCategories=[9]&countries=[${formData.country.value}]&orderBy=asc&limit=-1`
      )
      .then((response) => {
        const productData = response.data.products.map((product) => {
          return {
            label: product.name,
            value: product.id,
          };
        });
        setProductList(productData);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (formData.country.value) fetchProducts();
  }, [formData.country.value]);

  const onSubmit = () => {
    const isFormValid = validateForm(formData);
    if (isFormValid) {
      setIsTransportCreating(true);
      setCreateTransportAPIError("");
      // Create solution
      if (!id && !isEditMode) {
        axios
          .post("/transports", getFormData())
          .then(() => {
            setIsTransportCreating(false);
            updateRefeshStatus();
            onClose();
          })
          .catch((error) => {
            setIsTransportCreating(false);
            setCreateTransportAPIError(error.response?.data?.message ?? "");
          });
      }
      if (id && isEditMode) {
        axios
          .put(`/transports/${id}`, getFormData())
          .then(() => {
            setIsTransportCreating(false);
            updateRefeshStatus();
            onClose();
          })
          .catch((error) => {
            setIsTransportCreating(false);
            setCreateTransportAPIError(error.response?.data?.message ?? "");
          });
      }
    }
  };

  return (
    <Dialog>
      <div>
        <HeaderWrapper>
          <Title>{title}</Title>
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image
              src={closeIcon}
              alt="close transport popup"
              styles={{ width: "auto" }}
            />
          </Button>
        </HeaderWrapper>
        <FormBody>
          <OptionsWrapper>
            <FlexRow>
              <SectionContainer>
                <div>
                  <GridRow column="1fr">
                    <Dropdown
                      id="payterm-term-country"
                      label={t("COUNTRY")}
                      name="country"
                      value={formData.country.value}
                      onChange={onCountryChange}
                      defaultOption={t("COUNTRY")}
                      options={generalParams.countryList}
                      labelStyles={
                        formData.country.error !== ""
                          ? labelStylesError
                          : labelStyles
                      }
                      inputStyles={
                        formData.country.error !== ""
                          ? inputStylesError
                          : inputStyles
                      }
                      required
                      error={formData.country.error}
                    />
                  </GridRow>

                  <GridRow column="1fr">
                    <TextInput
                      id="label"
                      type="text"
                      label={t("TRANSPORT_TYPE_FORM_NAME")}
                      isFloat
                      required
                      value={String(formData.name.value)}
                      onChange={(e) => onNameChange(e)}
                      containerStyles={{ marginTop: "21px" }}
                      errorStyles={{ "font-style": "italic" }}
                      labelStyles={
                        formData.name.error !== ""
                          ? labelStylesError
                          : labelStyles
                      }
                      inputStyles={
                        formData.name.error !== ""
                          ? inputStylesError
                          : inputStyles
                      }
                      error={formData.name.error}
                      placeholder={t("TRANSPORT_TYPE_FORM_NAME")}
                    />
                  </GridRow>
                  <GridRow column="1fr 1fr 1fr 1fr">
                    <TextInput
                      id="transport-volume"
                      type="text"
                      label={t("TRANSPORT_TYPE_FORM_VOLUME")}
                      isFloat
                      required
                      value={String(formData.volume.value)}
                      onChange={(e) => onVolumeChange(e)}
                      containerStyles={{ marginTop: "21px" }}
                      errorStyles={{ "font-style": "italic" }}
                      labelStyles={
                        formData.volume.error !== ""
                          ? labelStylesError
                          : labelStyles
                      }
                      inputStyles={
                        formData.volume.error !== ""
                          ? inputStylesError
                          : inputStyles
                      }
                      error={formData.volume.error}
                      placeholder={t("TRANSPORT_TYPE_FORM_VOLUME")}
                    />

                    <TextInput
                      id="transport-avgWeight"
                      type="text"
                      label={t("TRANSPORT_TYPE_FORM_AVG_WEIGHT")}
                      isFloat
                      required
                      value={String(formData.avgWeight.value)}
                      onChange={(e) => onAvgWeightChange(e)}
                      containerStyles={{ marginTop: "21px" }}
                      errorStyles={{ "font-style": "italic" }}
                      labelStyles={
                        formData.avgWeight.error !== ""
                          ? labelStylesError
                          : labelStyles
                      }
                      inputStyles={
                        formData.avgWeight.error !== ""
                          ? inputStylesError
                          : inputStyles
                      }
                      error={formData.avgWeight.error}
                      placeholder={t("TRANSPORT_TYPE_FORM_AVG_WEIGHT")}
                    />
                    <TextInput
                      id="transport-minWeight"
                      type="text"
                      label={t("TRANSPORT_TYPE_FORM_MIN_WEIGHT")}
                      isFloat
                      required
                      value={String(formData.minWeight.value)}
                      onChange={(e) => onMinWeightChange(e)}
                      containerStyles={{ marginTop: "21px" }}
                      errorStyles={{ "font-style": "italic" }}
                      labelStyles={
                        formData.minWeight.error !== ""
                          ? labelStylesError
                          : labelStyles
                      }
                      inputStyles={
                        formData.minWeight.error !== ""
                          ? inputStylesError
                          : inputStyles
                      }
                      error={formData.minWeight.error}
                      placeholder={t("TRANSPORT_TYPE_FORM_MIN_WEIGHT")}
                    />
                    <TextInput
                      id="transport-maxWeight"
                      type="text"
                      label={t("TRANSPORT_TYPE_FORM_MAX_WEIGHT")}
                      isFloat
                      required
                      value={String(formData.maxWeight.value)}
                      onChange={(e) => onMaxWeightChange(e)}
                      containerStyles={{ marginTop: "21px" }}
                      errorStyles={{ "font-style": "italic" }}
                      labelStyles={
                        formData.maxWeight.error !== ""
                          ? labelStylesError
                          : labelStyles
                      }
                      inputStyles={
                        formData.maxWeight.error !== ""
                          ? inputStylesError
                          : inputStyles
                      }
                      error={formData.maxWeight.error}
                      placeholder={t("TRANSPORT_TYPE_FORM_MAX_WEIGHT")}
                    />
                  </GridRow>
                  <GridRow>
                    <Dropdown
                      id="trasnport-associated-product"
                      label={t("TRANSPORT_TYPE_FORM_PRODUCT")}
                      name="product"
                      value={formData.product.value}
                      onChange={onProductChange}
                      defaultOption={t("TRANSPORT_TYPE_FORM_PRODUCT")}
                      options={productList}
                      labelStyles={
                        formData.product.error !== ""
                          ? labelStylesError
                          : labelStyles
                      }
                      inputStyles={
                        formData.product.error !== ""
                          ? inputStylesError
                          : inputStyles
                      }
                      error={formData.product.error}
                    />
                  </GridRow>
                </div>
              </SectionContainer>
            </FlexRow>
          </OptionsWrapper>
        </FormBody>

        <ButtonWrapper>
          {createTransportAPIError && <div>{createTransportAPIError}</div>}
          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            onClick={onSubmit}
          >
            <>
              {isTransportCreating && <ClipLoader size={15} color="#fff" />}
              {!isTransportCreating && t("SUBMIT")}
            </>
          </Button>

          <Button
            styles={{
              color: "#333",
              background: "#fff",
              border: "1px solid #ccc",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={onClose}
          >
            {t("CLOSE")}
          </Button>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

AddEditTransport.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
  title: PropTypes.string.isRequired,
  isEditMode: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  updateRefeshStatus: PropTypes.func.isRequired,
};

AddEditTransport.defaultProps = {
  id: null,
  isEditMode: false,
};
export default withTranslation()(AddEditTransport);
